// extracted by mini-css-extract-plugin
export default {"SubmitButton":"SubmitButton_SubmitButton__rU1qa","Disabled":"SubmitButton_Disabled__i3bIU","Primary":"SubmitButton_Primary__q6QTv","Secondary":"SubmitButton_Secondary__G-bti"};